import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getAncillaryErrorById } from "../../../utils/ApiCalls/MobileAncillary";

const statusChipStyle = (status) => {
  const base = {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 500,
    color: "#fff",
  };
  switch ((status || "").toUpperCase()) {
    case "SUCCESS":
      return { ...base, background: "#0ab402" };
    case "CONTEXT_FAILED":
      return { ...base, background: "#eb6363" };
    case "ENROLLMENT_FAILED":
      return { ...base, background: "#d32f2f" };
    case "FAILED":
      return { ...base, background: "#b71c1c" };
    case "AUTHORISING":
      return { ...base, background: "#1976d2" };
    default:
      return { ...base, background: "#9e9e9e" };
  }
};

const fieldStyle = {
  display: "flex",
  gap: "8px",
  marginBottom: "10px",
  alignItems: "flex-start",
};

const labelStyle = {
  fontWeight: 600,
  minWidth: "180px",
  color: "#555",
  fontSize: "13px",
};

const valueStyle = {
  fontSize: "13px",
  color: "#222",
  wordBreak: "break-word",
};

const ViewError = () => {
  const { id } = useParams();
  const [, dispatch] = useDataLayerValue();
  const [lead, setLead] = useState(null);
  const [cybsExpanded, setCybsExpanded] = useState(false);

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Mobile Ancillary", route: "/shore/mobile-ancillary/error-module" },
    { title: "Error Module", route: "/shore/mobile-ancillary/error-module" },
    { title: "View", route: "#" },
  ];

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    dispatch({ type: "SET_LOADING", loading: true });
    const res = await getAncillaryErrorById(id);
    if (res.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: res.error, type: "error" },
      });
    } else {
      setLead(res.data || res);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  if (!lead) return null;

  const parsedCybsError = (() => {
    if (!lead.cybsRawError) return null;
    try {
      return JSON.stringify(
        typeof lead.cybsRawError === "string"
          ? JSON.parse(lead.cybsRawError)
          : lead.cybsRawError,
        null,
        2
      );
    } catch {
      return String(lead.cybsRawError);
    }
  })();

  return (
    <Layout type={"read_per"} module_data={"Error Module"}>
      <CustomHeaderTitle title={"View Error"} />
      <div>
        <HeaderBread navigation={navigation} title={"View Error"} />
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">

            {/* Payment Lead Details */}
            <div className="card" style={{ marginBottom: "20px" }}>
              <div className="card-header">
                <h5 style={{ margin: 0 }}>Payment Lead Details</h5>
              </div>
              <div className="card-body">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "4px 20px",
                  }}
                >
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Checkout Token:</span>
                    <span style={valueStyle}>{lead.checkoutToken || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Booking ID:</span>
                    <span style={valueStyle}>{lead.bookingId || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Vessel:</span>
                    <span style={valueStyle}>{lead.vessel || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Currency:</span>
                    <span style={valueStyle}>{lead.currency || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Amount:</span>
                    <span style={valueStyle}>
                      {lead.amount != null
                        ? `${lead.currency || ""} ${Number(lead.amount).toFixed(2)}`
                        : "-"}
                    </span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Status:</span>
                    <span>
                      <span style={statusChipStyle(lead.status)}>
                        {lead.status || "-"}
                      </span>
                    </span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Failed Stage:</span>
                    <span style={valueStyle}>{lead.failedStage || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Error Message:</span>
                    <span style={valueStyle}>{lead.errorMessage || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>CyberSource Txn ID:</span>
                    <span style={valueStyle}>{lead.cybsTransactionId || "-"}</span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Is Stuck:</span>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: 500,
                        color: "#fff",
                        background: lead.isStuck ? "#f5a623" : "#9e9e9e",
                      }}
                    >
                      {lead.isStuck ? "Yes" : "No"}
                    </span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Created At:</span>
                    <span style={valueStyle}>
                      {lead.createdAt
                        ? moment(lead.createdAt).format("DD-MM-YYYY HH:mm:ss")
                        : "-"}
                    </span>
                  </div>
                  <div style={fieldStyle}>
                    <span style={labelStyle}>Updated At:</span>
                    <span style={valueStyle}>
                      {lead.updatedAt
                        ? moment(lead.updatedAt).format("DD-MM-YYYY HH:mm:ss")
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* CyberSource Raw Error */}
            {parsedCybsError && (
              <div className="card">
                <div className="card-header">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5 style={{ margin: 0 }}>CyberSource Raw Error</h5>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => setCybsExpanded(!cybsExpanded)}
                      style={{ fontSize: "12px" }}
                    >
                      {cybsExpanded ? "Collapse" : "Expand"}
                    </button>
                  </div>
                </div>
                {cybsExpanded && (
                  <div className="card-body">
                    <pre
                      style={{
                        background: "#f5f5f5",
                        padding: "12px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "400px",
                        margin: 0,
                      }}
                    >
                      {parsedCybsError}
                    </pre>
                  </div>
                )}
              </div>
            )}

          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ViewError;
